import React, { createContext, useContext } from 'react';
interface PricingContextType {
  price: string;
  priceValue: number;
  currency: string;
  currencySymbol: string;
  isEurope: boolean;
  isLoading: boolean;
}
const PricingContext = createContext<PricingContextType>({
  price: '€590',
  priceValue: 590,
  currency: 'EUR',
  currencySymbol: '€',
  isEurope: true,
  isLoading: false
});
export function PricingProvider({
  children
}: {
  children: ReactNode;
}) {
  const value: PricingContextType = {
    price: '€590',
    priceValue: 590,
    currency: 'EUR',
    currencySymbol: '€',
    isEurope: true,
    isLoading: false
  };
  return <PricingContext.Provider value={value} data-id="element-356">{children}</PricingContext.Provider>;
}
export function usePricing() {
  return useContext(PricingContext);
}